import EfSpec from '@elem/ui/ef-spec';
import EfBlogLists from '@elem/ui/ef-blog-lists';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('power_kits_48v_system');
    const lists = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1723103278353/blog_01.jpg',
            title: t('R_card1_text'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1723103283247/blog_02.jpg',
            title: t('R_card2_text'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1723187376188/20240809.jpg',
            title: t('R_card3_text'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1723103294807/blog_04.jpg',
            title: t('R_card4_text'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1723103300691/blog_05.jpg',
            title: t('R_card5_text'),
        },
    ];

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-xx" />
            <EfBlogLists lists={lists} title={t('R_title')} />
        </div>
    );
}
